module.exports = __webpack_public_path__ + "media/complexity-selector/complex@1x-76d018ca.png";